import api from '@/utils/api';

/**
 * Get a quote by id
 * @param {string} quoteId - the quote id
 * @returns {Promise}
 */
const getQuoteApi = (quoteId) => {
  const url = `/quote/${quoteId}`;
  return api.get(url);
};

export default getQuoteApi;
